import { Arrears } from 'Feature/Arrears/components/ArrearsInquiryPage/core/Arrears';
import { DatePickerFormField } from 'Feature/Arrears/components/ArrearsInquiryPage/ui/common/form/DatePickerFormField';
import React from 'react';

export const ArrearsFlyoutReportingPeriodField = ({
  label,
  isReadOnly = true,
  arrears
}: {
  label: string;
  isReadOnly?: boolean;
  arrears: Arrears;
}) => {
  return (
    <DatePickerFormField
      label={label}
      isReadOnly={isReadOnly}
      error={false}
      value={arrears.reportingPeriodDate}
      dateFormat={'yyyy-MM-dd'}
    />
  );
};
